import { useStation } from '../../../core/stations/hooks/useStation';
import { FragmentTagGroup } from '@mi-front/core';

export function useFragmentTagGroups(stationId: string): FragmentTagGroup[] {
  const station = useStation(stationId);

  return station.featuresConfig?.fragments?.tagGroups || [];
}
